export default "__VITE_ASSET__39ab87a0__"